import * as React from 'react'
import { CheckinPerformanceCompleteManagerNotification } from '../../../../store/modules/notifications'
import { FormattedDateTime } from 'components/formatted-datetime'

export type CheckinPerformanceCompleteManagerProps = {
  notification: CheckinPerformanceCompleteManagerNotification
}

export const CheckinPerformanceCompleteManagerContent: React.FunctionComponent<
  CheckinPerformanceCompleteManagerProps
> = (props) => {
  const { notification } = props

  return (
    <div className="flex flex-col gap-y-0.5">
      <div>
        {notification.author && (
          <strong className="font-bold">{notification.author.fullName}</strong>
        )}{' '}
        completed a performance check-in
      </div>
      <div className="flex flex-row items-center justify-between gap-2 flex-wrap">
        <span className="text-theme-40">Review answers</span>
        <FormattedDateTime
          className="text-gray-600 text-xs"
          date={notification.createdAt}
        />
      </div>
    </div>
  )
}
